export default __webpack_public_path__ + "static/media/banana.a2bf96e8.png";